/** Surface → bridge session kind (`co-kfo-pia-surface-bridge-session-kind-mapping-20261007`). */
export type BridgeSessionKind = 'operational' | 'development' | 'transitional';

export function bridgeSessionKindForSurface(surface: string | null | undefined): BridgeSessionKind | null {
  if (surface === 'drive') return 'operational';
  if (surface === 'guidance') return 'development';
  if (surface === 'diagnose') return 'transitional';
  return null;
}

export function bridgeSessionKindLabel(kind: BridgeSessionKind): string {
  if (kind === 'operational') return 'Operational session';
  if (kind === 'development') return 'Development session';
  return 'Transitional session';
}
